import { openBlock as t, createElementBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "m10 16.4-4-4L7.4 11l2.6 2.6L16.6 7 18 8.4z"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
